import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] w-full flex items-center justify-center px-6 py-20">
      <div className="text-center max-w-md">
        <p className="text-teal-600 font-semibold text-sm tracking-wide mb-3">
          404
        </p>
        <h1 className="text-gray-800 font-semibold text-3xl mb-3">
          Page not found
        </h1>
        <p className="text-gray-500 text-sm mb-8">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-medium text-sm px-6 py-2.5 rounded-md transition-colors"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}